module.exports = __webpack_public_path__ + "9bec8a8133bf7b24e1cb78481f395c6e.jpg";